export class companyLoginRequest {
    usuario : string;
    password : string;
    recaptchaToken : string;
}